import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import './main.less';

import TablePropTypes from './prop-types';

import TableHead from './components/TableHead';
import TableBody from './components/TableBody';

import { getHeaders, getColumns } from './helper';
import { renderDefaultTH, renderDefaultTD } from './renderers';

function Table({ className, table, rows, payload, renderTH, renderTD }) {
	return (
		<table className={cn('new-table', className)}>
			<TableHead
				headers={getHeaders(table)}
				renderTH={renderTH}
			/>
			<TableBody
				columns={getColumns(table)}
				renderTD={renderTD}
				rows={rows}
				payload={payload}
			/>
		</table>
	);
}

Table.propTypes = {
	className: PropTypes.string,
	table: TablePropTypes.TablePropType,
	rows: TablePropTypes.RowsPropType,
	payload: TablePropTypes.PayloadPropType,
	renderTH: TablePropTypes.RenderPropType,
	renderTD: TablePropTypes.RenderPropType
};

Table.defaultProps = {
	payload: {},
	renderTH: renderDefaultTH,
	renderTD: renderDefaultTD
};

export default Table;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-table/main.js